export default "__VITE_ASSET__18iSr2I4__"